import { Link } from "react-router-dom";
import { LEGAL_DOCS, SUPPORT_EMAIL } from "../../content/legal";
import { Wordmark } from "./Header";

const Column = ({ title, children, testId }) => (
  <div>
    <h3 className="font-spartan text-[14px] font-bold text-black md:text-[15px]">
      {title}
    </h3>
    <ul className="mt-4 space-y-3 md:mt-6 md:space-y-[22px]" data-testid={testId}>
      {children}
    </ul>
  </div>
);

const FooterLink = ({ to, children, testId }) => (
  <li>
    <Link
      to={to}
      data-testid={testId}
      className="font-glacial text-[14px] leading-none text-[#555555] transition-colors hover:text-black md:text-[15px]"
    >
      {children}
    </Link>
  </li>
);

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="mt-auto w-full bg-[#F7F6F4]"
    >
      <div className="mx-auto grid w-full max-w-[1366px] grid-cols-1 gap-10 px-5 py-12 sm:grid-cols-2 md:grid-cols-[1.6fr_1fr_1fr_1.3fr] md:px-[77px] md:py-[64px]">
        <div>
          <Link
            to="/"
            data-testid="footer-logo-link"
            aria-label="Vibealone home"
            className="inline-block rounded-sm focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-black"
          >
            <Wordmark className="text-[26px] md:text-[30px]" />
          </Link>
          <p className="mt-3 font-dmsans text-[14px] text-[#555555] md:mt-4 md:text-[15px]">
            Billions of experiences
          </p>
        </div>

        <Column title="Navigate" testId="footer-navigate">
          <FooterLink to="/" testId="footer-nav-home">
            Home
          </FooterLink>
        </Column>

        <Column title="Legal" testId="footer-legal">
          {LEGAL_DOCS.map((doc) => (
            <FooterLink
              key={doc.slug}
              to={doc.slug}
              testId={`footer-legal-${doc.slug.slice(1)}`}
            >
              {doc.navLabel}
            </FooterLink>
          ))}
        </Column>

        <Column title="Support" testId="footer-support">
          <li>
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              data-testid="footer-support-email"
              className="font-glacial text-[14px] leading-none text-[#555555] transition-colors hover:text-black md:text-[15px]"
            >
              {SUPPORT_EMAIL}
            </a>
          </li>
        </Column>
      </div>
    </footer>
  );
}
